import { createPortal } from 'react-dom';
import TodoDrawer from 'views/Todo/components/TodoDrawer';
import useModal from 'hooks/useModal';
import { useMount, useRequest } from 'ahooks';
import { getTodoDetail } from 'views/Conversation/Sider/ToDoBundle/api';
import { message } from 'antd';
import { useTranslate } from '@tolgee/react';

export const Todo = (props: { id: string }) => {
  const { id } = props;
  const { t } = useTranslate();
  const { runAsync, loading } = useRequest((id) => getTodoDetail(id), {
    manual: true,
    onError: () => {
      message.error(t('phrase.获取数据失败，请稍后再试'));
    },
  });
  useMount(() => {
    runAsync(id).then((res: any) => {
      show(res);
    });
    // e
  });
  const { visible, show, hide, meta } = useModal<Todo.Record>();
  const drawer = meta && (
    <TodoDrawer
      enableAcquireControl
      todo={meta}
      visible={visible}
      onClose={() => hide()}
      readonly
    />
  );

  if (loading) return null;
  return createPortal(drawer, document.body);
};
